import React from "react";

const Logo = ({
  width,
  height,
  handleClick,
  cursor,
  warnerLogo,
  hotelTitle,
}) => {
  return (
    <>
      {warnerLogo ? (
        <img
          src={"/img/logos/warner_logo.png"}
          style={{ width, height, cursor }}
          onClick={handleClick}
        />
      ) : (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src={"/img/logos/warner_new.svg"}
            style={{ width, height, cursor }}
            onClick={handleClick}
          />
          {hotelTitle ? (
            <div
              style={{
                color: "#fff",
                width: "100%",
                textAlign: "center",
                fontSize: "14px",
              }}
            >{`at ${hotelTitle}`}</div>
          ) : null}
        </div>
      )}
    </>
  );
};

export default Logo;
